import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { GiftLanding } from '#app/components/gift-landing'

export const handle: SEOHandle = {
	getSitemapEntries: () => [{ route: '/gifts/where-we-met' }],
}

export const meta = () => [
	{ title: 'Where We Met: A Personal Digital Map Gift | Erda' },
	{
		name: 'description',
		content:
			'Give the place where your story began. Choose a digital place near where you first met, add a personal message and fund trees for $2 per place per year.',
	},
	{
		property: 'og:title',
		content: 'Give the place where you first met | Erda',
	},
	{ property: 'og:url', content: 'https://erda.app/gifts/where-we-met' },
	{ property: 'og:type', content: 'website' },
]

export default function WhereWeMetGift() {
	return <GiftLanding occasion="where-we-met" />
}
